import { render, staticRenderFns } from "./Frais.vue?vue&type=template&id=79b10277"
import script from "./Frais.vue?vue&type=script&lang=js"
export * from "./Frais.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports